import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa6";
import { whatsappUrl } from "../data/site";
import { trackEvent } from "../lib/analytics";

/**
 * Botón flotante de WhatsApp. Aparece recién después de que el usuario
 * scrollea, para no tapar el hero al entrar.
 */
const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noreferrer"
      aria-label="Escribinos por WhatsApp"
      onClick={() => trackEvent("contact_click", { method: "whatsapp", location: "float_button" })}
      className={`group fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:scale-105 hover:shadow-2xl ${
        visible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <span
        className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-20"
        aria-hidden="true"
      />
      <FaWhatsapp size={28} aria-hidden="true" />

      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-lg bg-campo-950 px-3 py-2 text-xs font-semibold text-white opacity-0 shadow-lg transition-opacity duration-200 group-hover:opacity-100 lg:block">
        ¿Hablamos?
      </span>
    </a>
  );
};

export default WhatsAppFloat;
